export const getUser = require("./getUser").getUser
export const getPuzzle = require("./getPuzzle").getPuzzle
export const getPuzzles = require("./getPuzzles").getPuzzles
